<template>
  <b-modal
    ref="scoutConfirmModal"
    id="scoutConfirmModal"
    modal-class="scout-confirm-modal"
    size="md"
    backdrop="static"
    centered
    hide-header
    :z-index="1060"
  >
  <div class="confirmation-content d-flex flex-column align-items-center">
    <p class="text-center" style="font-weight: bold; font-size: 20px;">スカウト希望しますか？</p>
    <p class="text-center" style="font-weight: bold; font-size: 20px;">
      求人への興味が企業に直接伝わり<br />
      スカウトが届きやすくなります
    </p>
    <p class="mt-4 font-12">
      ・1社につき1求人スカウト希望ができます。<br />
      ・スカウト希望後の取り下げはできません。スカウト希望から1週間経過後、同じ企業の別の求人にスカウト希望ができます。
    </p>
  </div>
    <template #modal-footer>
      <div class="d-flex  w-100 align-items-center button-flex flex-row">
        <b-button 
          class="next-button" 
          @click="$emit('cancel')"
          :disabled="loading"
        >キャンセル</b-button
        >
        <b-button 
          class="scout-button" 
          @click="$emit('confirm')"
          :disabled="loading"
        >
          <span v-if="loading">送信中...</span>
          <span v-else>スカウト希望する</span>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "ScoutConfirmationModal",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    show() {
      this.$refs.scoutConfirmModal.show();
    },
    hide() {
      this.$refs.scoutConfirmModal.hide();
    },
  },
};
</script>

<style scoped>
.button-flex {
  justify-content: space-around;
}

.font-12 {
  font-size: 12px;
}

.scout-confirm-modal .modal-footer {
  background: #ffffff !important;
  border-top: none !important;
  justify-content: center !important;
}

.scout-confirm-modal .confirmation-content {
  padding: 50px 10px;
}

.text-center {
  text-align: center;
}

.scout-button:disabled,
.next-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* Mobile responsive styles for button container */
@media (max-width: 768px) {
  .button-flex {
    flex-direction: column !important;
    justify-content: center !important;
    align-items: center !important;
    gap: 12px;
  }

  .scout-button {
    order: 1;
    width: 318px !important;
    min-width: 84px;
    max-width: 480px;
    height: 53px !important;
    border-radius: 3px !important;
  }

  .next-button {
    order: 2;
    width: 318px !important;
    min-width: 84px;
    max-width: 480px;
    height: 53px !important;
    border-radius: 3px !important;
  }
}
</style>

<style>
#scoutConfirmModal .modal-footer {
  border-top: none !important;
}
</style>
